import { Route } from "react-router-dom";
import { CLIENT_ROUTES } from "../../config/routes";
import { ProjectsRoutes } from "./projects.routes";
import CenteredSpinner from "../../components/centered-spinner/CenteredSpinner";
import loadable from "@loadable/component";

const options =  {
  fallback : <CenteredSpinner />
}

const ClientHome = loadable(() => import (/* webpackChunkName: "ClientHome" */ '../../pages/client/home/ClientHome') , options)
const Faq = loadable(() => import (/* webpackChunkName: "Faq" */ '../../pages/client/faq/Faq') , options)
const ConnectPage = loadable(() => import (/* webpackChunkName: "ConnectPage" */ '../../pages/client/components/connect-page/ConnectPage') , options)
const FaqCategoryPage = loadable(() => import (/* webpackChunkName: "FaqCategoryPage" */ '../../pages/client/faq/faq-category/FaqCategoryPage') , options)
const PastInvoices = loadable(() => import (/* webpackChunkName: "PastInvoices" */ '../../pages/client/past-invoices/PastInvoices') , options)

export function ClientRoutes() {
  return (
    <>
      <Route index element={<ClientHome />} />
      {ProjectsRoutes()}
      <Route path={CLIENT_ROUTES.FAQ.ROOT}>
        <Route index element={<Faq />} />
        <Route path={CLIENT_ROUTES.FAQ.CATEGORY} element={<FaqCategoryPage />} />
      </Route>
      <Route path={CLIENT_ROUTES.CONNECT} element={<ConnectPage />} />
      <Route path={CLIENT_ROUTES.PAST_INVOICES} element={<PastInvoices />} />
      {/* <Route path={CLIENT_ROUTES.ONBOARDING} element={<Onboarding />} /> */}
    </>
  )
}